module.exports = __webpack_public_path__ + "static/media/certjoinLogo.4cc9189c.png";